import { debounce } from 'lodash';

const keyboardAnimationDuration = 250;

export function scrollActiveElementIntoView() {
  document.activeElement?.scrollIntoView({
    behavior: 'smooth',
    block: 'nearest',
    inline: 'nearest',
  });
}

export const debouncedScrollActiveElementIntoView = debounce(
  scrollActiveElementIntoView,
  keyboardAnimationDuration,
);

export function scrollNodeIntoViewIfNotVisible(node: Element | null) {
  if (!node) {
    return;
  }
  if (
    node.getBoundingClientRect().top > 0 &&
    node.getBoundingClientRect().bottom < window.innerHeight
  ) {
    return;
  }
  node.scrollIntoView({ block: 'center', behavior: 'instant' });
}
